import { helpers } from '@teamrazr/redux'
export default helpers.createApiReducer('channels')
